class WooCommerceOrdering {
    constructor() {
        this.init();
    }

    init() {
        const buttons = document.querySelectorAll('form.woocommerce-ordering button');
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const selected = button.parentElement.querySelector('.selected');
                if (selected) {
                    selected.classList.remove('selected');
                }

                button.classList.add('selected');
            });
        });
    }
}

new WooCommerceOrdering();
export default WooCommerceOrdering;
